(function (angular) {

  angular.module("alk.maps", ["alk.geocode", "alk.constants"]);

})(window.angular);


// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-maps/module.js